// extracted by mini-css-extract-plugin
module.exports = {"confirm-modal-wrapper":"ConfirmModal_confirm-modal-wrapper__1f0IQ","confirm-modal-body":"ConfirmModal_confirm-modal-body__1uu5_","title":"ConfirmModal_title__eYx3x"};